<template>
    <div id="lab">

        <GameChatGPTTest />

    </div>

    <Contact />
</template>

<script>
import GameChatGPTTest from "../components/GameChatGPTTest.vue";
import Contact from "../components/Contact.vue";

export default {
    name: "Lab",
    data() {
        return {
            isMobile: false,
            isDisplay: false,
        };
    },
    components: {
        GameChatGPTTest,
        Contact,
    },
    created() {},
    methods: {},
};
</script>

<style lang="scss" scoped>
#lab {
    padding-top: 100px;
    position: relative;
    max-width: 1400px;
    margin: 0 auto 200px;
}
</style>
